/**
 * Jumps to the given element.
 * @param  {HTMLElement} node
 * @param  {number} offset - Optional offset from top (e.g., for fixed headers)
 */
export default function scrollToElementDomUtil (node, offset = 100) {
  const top = node.offsetTop - offset
  window.scrollTo({
    top,
    behavior: 'smooth'
  })
}
